import * as fullstoryBrowser from '@fullstory/browser';
import { useContext } from 'react';
import FullstoryBrowser from '../contexts/fullstory-browser.js';
export default function useFullstoryBrowser() {
    return useContext(FullstoryBrowser) ?? fullstoryBrowser;
}
//# sourceMappingURL=use-fullstory-browser.js.map